import { Record } from 'immutable';
import { PartyType } from './party-type';

const PartyForUnmatchEventRecord = Record({
  type: null,
  code: null,
  name: null,
  address: null
});

export class PartyForUnmatchEvent extends PartyForUnmatchEventRecord {
  type: PartyType;
  code: string;
  name: string;
  address: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party-for-unmatch-event.ts